import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheck, Truck, Zap } from 'lucide-react';
interface CTASectionProps {
  variant?: 'mid' | 'final';
}
export function CTASection({
  variant = 'mid'
}: CTASectionProps) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true
  }} className="my-16 relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#9AC1F0] to-[#7BA8D8] text-white shadow-2xl p-8 md:p-12 text-center" data-id="element-62">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-63">
        <div className="absolute -top-24 -left-24 w-64 h-64 rounded-full bg-white blur-3xl" data-id="element-64"></div>
        <div className="absolute -bottom-24 -right-24 w-64 h-64 rounded-full bg-[#FFD700] blur-3xl" data-id="element-65"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto space-y-6" data-id="element-66">
        <div className="inline-block bg-[#FFD700] text-[#9AC1F0] px-4 py-1 rounded-full font-black uppercase tracking-wider text-sm mb-2 animate-pulse" data-id="element-67">
          Limited Time Offer
        </div>

        <h2 className="text-3xl md:text-5xl font-bold leading-tight" data-id="element-68">
          Get Up To <span className="text-[#FFD700]" data-id="element-69">42% OFF</span> Today!
        </h2>

        <p className="text-lg text-purple-100" data-id="element-70">
          Join 10,000+ happy pet parents. Try it risk-free with our 30-day
          money-back guarantee.
        </p>

        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 inline-block w-full max-w-md border border-white/20" data-id="element-71">
          <div className="text-sm font-medium text-purple-200 mb-2 uppercase tracking-widest" data-id="element-72">
            Deal Ending In
          </div>
          <CountdownTimer variant="light" className="justify-center text-2xl md:text-3xl" data-id="element-73" />
        </div>

        <div className="pt-4" data-id="element-74">
          <Button variant="secondary" size="xl" fullWidth className="shadow-xl shadow-black/20 text-[#9AC1F0]" href="https://snugges.com/products/dogs-liquid-lick-bowl" data-id="element-75">
            GET 42% OFF NOW <span className="ml-2" data-id="element-76">👉</span>
          </Button>
        </div>

        <div className="flex flex-wrap justify-center gap-4 text-sm font-medium text-purple-200 pt-4" data-id="element-77">
          <div className="flex items-center gap-1" data-id="element-78">
            <Zap className="w-4 h-4 text-[#FFD700]" data-id="element-79" />
            Sell-Out Risk: <span className="text-white font-bold" data-id="element-80">HIGH</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-81">
            <Truck className="w-4 h-4 text-[#FFD700]" data-id="element-82" />
            Free Shipping
          </div>
          <div className="flex items-center gap-1" data-id="element-83">
            <ShieldCheck className="w-4 h-4 text-[#FFD700]" data-id="element-84" />
            30-Day Guarantee
          </div>
        </div>
      </div>
    </motion.div>;
}